import { FC } from "react";
import { Routes, Route } from "react-router-dom";
import TripDetailsReport from "./components/TripDetailsReport";
import ReportsDashboard from "./components/ReportsDashboard";

export const ReportsRouter: FC<{}> = () => {
  return (
    <Routes>
      <Route index element={<ReportsDashboard />} />
      <Route path="trip-details/:tripId" element={<TripDetailsReport />} />
      <Route path="popup/trip-details/:tripId" element={<TripDetailsReport />} />
    </Routes>
  );
};
